<ng-container
  *ngIf="{
    searchLoading: searchLoading$ | async,
    searchError: searchError$ | async,
    searchResult: searchResult$ | async,
  } as obs"
>
  <sd-input-autocomplete
    #searchRef
    [items]="[]"
    placeholder="Поиск"
    [loading]="obs.searchLoading"
    [minLength]="searchPhraseMinLength"
    [maxLength]="searchPhraseMaxLength"
    (changeInput)="changeSearchPhraseEvent$.next($event)"
  ></sd-input-autocomplete>

  <ng-container *ngIf="(!obs.searchError && obs.searchResult.length > 0) || obs.searchLoading; else notFound">
    <sd-order-documents-table
      [items]="obs.searchResult"
      [loading]="obs.searchLoading"
      [pageSize]="pageSize"
    ></sd-order-documents-table>
    <sd-pagination
      #paginationRef
      [pagination]="pagination$ | async"
      (viewPageEvent)="changeCurrentPageEvent$.next($event)"
    ></sd-pagination>
  </ng-container>

  <ng-template #notFound>
    <div class="not-found-text">По вашему запросу документы не найдены</div>
  </ng-template>
</ng-container>
